import { toString } from 'lodash';
import ILoginResponse from 'types/auth/ILoginResponse';
import IToken from 'types/auth/IToken';

export const fromLoginResponseToToken = (data: ILoginResponse): IToken => {
  return {
    token: toString(data?.token),
    role: toString(data?.role),
    hasMultifactor: data?.hasMultifactor,
    needsReset: data?.needsReset,
  };
};
